import { JobFromAPI } from '../types';
import { transformJob } from './api-transforms';
import apiRequest from './apiRequest';

export default async function getJob(jobID: string, animationNumber?: number) {
  const { data, error } = await apiRequest<JobFromAPI>(
    'mogen-orchestration',
    `/jobs/${jobID}${
      animationNumber ? `?animationNumber=${animationNumber}` : ''
    }`,
  );

  return { data: transformJob(data), error };
}
